import DeleteSvgComponent from "@assets/svg-components/delete";
import EditSvgComponent from "@assets/svg-components/edit";
import { getColorStyle } from "@common/color";
import {
  convertCurrentDate,
  convertCurrentDateWithTime,
} from "@common/date-helpers";
import { concatString, formatText } from "@common/text-helpers";
import { getValue } from "@utils/lodash";
import React from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

function EmailTemplateTable(props: any) {
  const { templateList } = props;
  return (
    <div>
      <table className="datatable_table">
        <thead className="datatable_table_thead">
          <th className="datatable_table_th" style={{ width: "70px" }}>
            <label className="m-0 position-relative" htmlFor="header-checkbox">
              <input
                type="checkbox"
                className="default-checkbox"
                id="header-checkbox"
                onChange={() =>
                  props.handleCheckAll(
                    getValue(props, `templateList.length`, 0) ===
                      getValue(props, `selectedIDs.length`, 0)
                      ? "All"
                      : "None"
                  )
                }
                checked={
                  getValue(props, `templateList.length`, 0) ===
                  getValue(props, `selectedIDs.length`, 0)
                }
              />
              <div className="custom-checkbox">
                <img
                  src="/images/uploaded-details/tick.svg"
                  className="img-fluid uploaded-tick"
                />
              </div>
            </label>
          </th>
          <th className="datatable_table_th" style={{ width: "400px" }}>
            <h6 className="">Type</h6>
          </th>
          <th className="datatable_table_th" style={{ width: "400px" }}>
            <h6 className="">Subject</h6>
          </th>
          <th className="datatable_table_th">
            <h6 className="">Status</h6>
          </th>
          {/* <th className="datatable_table_th">
            <h6 className="">Added on</h6>
          </th> */}
          <th className="datatable_table_th" style={{ width: "100px" }}>
            <h6 className="">Action</h6>
          </th>
        </thead>
        <tbody className="datatable_table_tbody">
          {getValue(templateList, `length`, 0) > 0 &&
            templateList.map((bodyObj: object, index: number) => {
              return (
                <tr key={index} className="datatable_table_tr">
                  <td className="datatable_table_td" style={{ width: "70px" }}>
                    <label
                      className="m-0 position-relative"
                      htmlFor={`header-checkbox-${index}`}
                    >
                      <input
                        type="checkbox"
                        className="default-checkbox"
                        id={`header-checkbox-${index}`}
                        onChange={() =>
                          props.handleCheckUsers(getValue(bodyObj, `id`, ""))
                        }
                        checked={getValue(props, `selectedIDs`, []).includes(
                          getValue(bodyObj, `id`, "")
                        )}
                      />
                      <div className="custom-checkbox">
                        <img
                          src="/images/uploaded-details/tick.svg"
                          className="img-fluid uploaded-tick"
                        />
                      </div>
                    </label>
                  </td>
                  <td className="datatable_table_td">
                    <h6 className="color_primary header_text__14">
                      {concatString(
                        formatText(getValue(bodyObj, `type`, "")),
                        50
                      )}
                    </h6>
                  </td>
                  <td className="datatable_table_td">
                    <h6 className="">
                      {concatString(getValue(bodyObj, `subject`, ""), 40)}
                    </h6>
                  </td>
                  <td className="datatable_table_td">
                    <h6
                      className=""
                      style={getColorStyle(
                        getValue(bodyObj, `is_active`, false)
                          ? "Active"
                          : "Inactive"
                      )}
                    >
                      {getValue(bodyObj, `is_active`, "")
                        ? "Active"
                        : "Inactive"}
                    </h6>
                  </td>
                  {/* <td className="datatable_table_td">
                    <h6
                      className="title-"
                      // data-tip
                      // data-for={`location${index}`}
                    >
                      {getValue(bodyObj, `created_at`, null)
                        ? convertCurrentDateWithTime(
                            getValue(bodyObj, `created_at`, null)
                          )
                        : null}
                    </h6>
                  </td> */}
                  <td
                    className="datatable_table_td action-icon-td"
                    style={{ width: "100px" }}
                  >
                    {/* <div className="d-flex align-items-center">
                      <div
                        onClick={() =>
                          props.handleEditEntity(getValue(bodyObj, `id`, ""))
                        }
                      >
                        <EditSvgComponent />
                      </div>
                      <div
                        onClick={() =>
                          props.handleDeleteFun(
                            getValue(bodyObj, `id`, ""),
                            getValue(bodyObj, `subject`, "")
                          )
                        }
                      >
                        <DeleteSvgComponent />
                      </div>
                    </div> */}
                    {getValue(props, `permissions`, []).includes("update") && (
                      <UncontrolledDropdown
                        className="table-action-icon-wrap me-4"
                        direction="start"
                        container={"body"}
                      >
                        <DropdownToggle>
                          <div className="switch_header__dropdown m-0 align-items-center">
                            <div className="close-image_container action-icon-wrap">
                              <img
                                src={"/images/more.svg"}
                                className=" close_image"
                              />
                            </div>
                          </div>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem>
                            <div
                              className={`more-dropdown-main-item `}
                              onClick={() =>
                                props.handleEditEntity(
                                  getValue(bodyObj, `id`, "")
                                )
                              }
                            >
                              Edit
                            </div>
                          </DropdownItem>
                          <DropdownItem>
                            <div
                              className={`more-dropdown-main-item `}
                              onClick={() =>
                                props.handleDeleteFun(
                                  getValue(bodyObj, `id`, ""),
                                  getValue(bodyObj, `subject`, "")
                                )
                              }
                            >
                              Delete
                            </div>
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}

export default EmailTemplateTable;
